export const API_WEBCHAT = 'webChat';
export const API_LAB = 'labResults';
export const API_ACCOUNT_MANAGEMENT = 'accountManagement';
export const API_EMC = 'emc';
export const API_FILE = 'file';
export const API_CONSULT = 'consult';
export const API_EMR = 'emr';
export const API_APPOINTMENT = 'appointment';
export const API_IAM = 'iam';
export const API_PRESCRIPTION = 'prescription';
export const API_HEALTH_SUMMARY = 'healthSummary';
export const API_ALERT = 'alert';
export const API_NOTIFICATION = 'notification';
export const API_BPDATA = 'bpdata';
export const API_SEARCH = 'search';
export const API_INVOICE = 'invoice';
export const API_REPORT = 'report';
export const API_MANAPAY = 'manapay';
export const API_MARKETPLACE = 'marketplace';
export const API_AI = 'ai';
